import { Link } from '@inertiajs/react'
import { Brain, Calendar, FileText } from 'lucide-react'
import { nextRunLabelFromMs } from '@/frontend/features/HomeWork/format'
import type { LinkedRoutine, ProcessMemory } from './types'

// "Próximos agendamentos" (Onda C): as próximas execuções das rotinas
// vinculadas (next_run_at_ms real do cron.list). Some quando não há agenda.
export function UpcomingRunsSidePanel({ runs }: { runs: LinkedRoutine[] }) {
  const items = runs
    .map((routine) => ({ routine, label: nextRunLabelFromMs(routine.next_run_at_ms) }))
    .filter((entry): entry is { routine: LinkedRoutine; label: string } => entry.label !== null)

  if (items.length === 0) return null

  return (
    <section aria-label="Próximos agendamentos" className="overflow-hidden rounded-xl border border-border bg-card">
      <header className="flex items-center gap-2 px-4 pb-1.5 pt-3">
        <Calendar className="size-3.5 text-faint-foreground" aria-hidden />
        <h3 className="text-[11px] font-semibold uppercase tracking-[0.08em] text-faint-foreground">Próximos agendamentos</h3>
      </header>
      <ul>
        {items.map(({ routine, label }) => (
          <li key={routine.id} className="flex items-center gap-2.5 border-t border-border px-4 py-2.5">
            <Calendar className="size-3.5 flex-none text-faint-foreground" aria-hidden />
            <div className="min-w-0 flex-1">
              <p className="truncate text-[13px] font-medium text-foreground">{label}</p>
              <p className="truncate font-mono text-[11px] text-faint-foreground">{routine.name}</p>
            </div>
          </li>
        ))}
      </ul>
    </section>
  )
}

// "Memória & skill" (Onda C): o slug da skill publicada + link para o dossiê
// (a página de Memória do agente). Honesto: a árvore de conhecimento não tem
// FK por processo, então linkamos a seção do agente, não um arquivo por processo.
export function MemorySidePanel({ memory }: { memory: ProcessMemory }) {
  return (
    <section aria-label="Memória e instruções" className="overflow-hidden rounded-xl border border-border bg-card">
      <header className="flex items-center gap-2 px-4 pb-1.5 pt-3">
        <Brain className="size-3.5 text-faint-foreground" aria-hidden />
        <h3 className="text-[11px] font-semibold uppercase tracking-[0.08em] text-faint-foreground">Memória e instruções</h3>
      </header>

      <div className="flex items-center gap-2.5 border-t border-border px-4 py-2.5">
        <FileText className="size-3.5 flex-none text-faint-foreground" aria-hidden />
        <div className="min-w-0 flex-1">
          <p className="truncate text-[13px] font-medium text-foreground">
            {memory.has_published_skill ? 'Instruções disponíveis' : 'Instruções ainda não disponíveis'}
          </p>
          <p className="truncate font-mono text-[11px] text-faint-foreground">Identificador: {memory.skill_slug}</p>
        </div>
      </div>

      <Link
        href={memory.memory_path}
        className="flex items-center gap-2.5 border-t border-border px-4 py-2.5 transition-colors duration-150 hover:bg-accent"
      >
        <Brain className="size-3.5 flex-none text-faint-foreground" aria-hidden />
        <div className="min-w-0 flex-1">
          <p className="truncate text-[13px] font-medium text-foreground">Memória do colaborador</p>
          <p className="truncate text-[11px] text-muted-foreground">Ver o dossiê e as instruções</p>
        </div>
      </Link>
    </section>
  )
}
